import BIGV_Player from "../Pages/BIGV_Player"
import BIGV_Staff from "../Pages/BIGV_Staff"
import BIGV_Delegate from "../Pages/BIGV_Delegate"
import functions from "../../Data/Functions"

// Load Models
const LoadModel = async (Passed) => {
    let result = {}
    switch (Passed.Type) {
        // Player Form
        case 'Player':
            result = await BIGV_Player.LoadSchema(Passed)
            break;
        //Staff Form
        case 'Staff':
            result = await BIGV_Staff.LoadSchema(Passed)
            break;
        //Delegate Form
        case 'Delegate':
            result = await BIGV_Delegate.LoadSchema(Passed)
            break;
        // Maintenance Mode
        case 'Maintenance':
            result = {
                Portal: '2024 BigV Registration Portal',
                // MainColor: "#0305a1",
                MainColor: "#f5924c",
                Logo: require(`../../assets/BigVLogoNewT.png`),
                Title: `<h2>2024 BigV Registration Portal</h2>`,
                Description: ``,
                // Suspended: Maintenance,
                steps: [
                    // Step 1
                    {
                        stepno: 1,
                        title: 'Registrations Suspended Due to Maintence',
                        valid: true,
                        information: '',
                        Model: {},
                        Schema: {
                            maintenance: {
                                type: 'img',
                                src: 'https://admin.ownurgoal.net.au/_lib/file/imgArticles/Maintenance.png',
                                height: "100%",
                                width: "100%",
                                //maxHeight: 1366,
                                //maxWidth: 768,
                                // contain: true,
                                col: 12,
                                class: "ma-2"
                            },
                        }
                    },
                ]
            }
            break;

        case 'Closed':
            result = {
                Portal: '2024 BigV Registrations',
                // MainColor: "#0305a1",
                MainColor: "#f5924c",
                Logo: require(`../../assets/BigVLogoNewT.png`),
                Title: `<h2>2024 Big V Registration Portal</h2>`,
                Description: ``,
                // Suspended: suspened,
                steps: [
                    // Step 1
                    {
                        stepno: 1,
                        title: 'Registrations Suspended',
                        valid: true,
                        information: `
                            <H1 style="text-align:center;color:red">New registrations for this round are now closed.</H1>
                            </p>
                            </p>
                            <H3 style="text-align:center;color:Orange">Registrations close at 4pm Friday prior to each weekend round as per the Big V Rules of Operation</H3>
                            </p>
                            <H3 style="text-align:center;color:Orange">Submission of registrations for the remainder of the season will re-open at Monday 9am.</H3>
                            </p>
                            </p>
                            </p>`,
                        Model: {},
                        Schema: {}
                    },
                ]
            }
            break;


        default:
            break;
    }
    // Load the Model with step elements
    result.steps.forEach(element => {
        element.Model = result.Model
    });
    return result
}

export default {
    init: async (Parameters) => {
        let currentState = await functions.getData("SELECT * FROM System_Settings WHERE `Key` = 'BIGV_Portal'", false)
        if (currentState[0].Value === 'Closed') {
            Parameters.Type = 'Closed'
        }
        if (currentState[0].Value === 'Maintenance') {
            Parameters.Type = 'Maintenance'
        }
        let result = await LoadModel(Parameters)
        return result;
    },
}

